// KYC: Actions for getting KYC data which user needs to respond to.
import { Dispatch } from 'redux';

import { get, RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import { AppState } from '../reducers';
import { customFailed } from '../util/common';
import { errorNames } from '../util/mappings/errorName';
import { getRequestHeaders } from './tools';
import { actionTypes, AppActions } from './types';

type Action<T> = import('./types').Action<T>;
type CustomerKycResponse = import('../generated-types').CustomerKYCResponse;

export interface FetchCustomerKycStartedAction extends Action<typeof actionTypes.FETCH_CUSTOMER_KYC_STARTED> {
    type: typeof actionTypes.FETCH_CUSTOMER_KYC_STARTED;
}

export interface FetchCustomerKycFulfilledAction extends Action<typeof actionTypes.FETCH_CUSTOMER_KYC_FULFILLED> {
    type: typeof actionTypes.FETCH_CUSTOMER_KYC_FULFILLED;
    payload: CustomerKycResponse;
}

export interface FetchCustomerKycFailedAction extends Action<typeof actionTypes.FETCH_CUSTOMER_KYC_FAILED> {
    type: typeof actionTypes.FETCH_CUSTOMER_KYC_FAILED;
    payload: RequestExceptionWithResponse;
}

export interface SetKycAnsweredAction extends Action<typeof actionTypes.SET_KYC_ANSWERED> {
    type: typeof actionTypes.SET_KYC_ANSWERED;
}

export interface KycErrorAction extends Action<typeof actionTypes.KYC_ERROR> {
    type: typeof actionTypes.KYC_ERROR;
}

export interface KycSkipAction extends Action<typeof actionTypes.KYC_SKIP> {
    type: typeof actionTypes.KYC_SKIP;
}

export type KycActions =
    | FetchCustomerKycStartedAction
    | FetchCustomerKycFulfilledAction
    | FetchCustomerKycFailedAction
    | SetKycAnsweredAction
    | KycErrorAction
    | KycSkipAction;

export const fetchCustomerKycStarted = (): FetchCustomerKycStartedAction => ({
    type: actionTypes.FETCH_CUSTOMER_KYC_STARTED,
});
export const fetchCustomerKycFulfilled = (json: CustomerKycResponse): FetchCustomerKycFulfilledAction => ({
    type: actionTypes.FETCH_CUSTOMER_KYC_FULFILLED,
    payload: json,
});
export const fetchCustomerKycFailed = (error: RequestExceptionWithResponse): FetchCustomerKycFailedAction => ({
    type: actionTypes.FETCH_CUSTOMER_KYC_FAILED,
    payload: error,
});

export const setKycAnswered = (): SetKycAnsweredAction => ({
    type: actionTypes.SET_KYC_ANSWERED,
});

export const kycError = (): KycErrorAction => ({
    type: actionTypes.KYC_ERROR,
});

export const skipKyc = (): KycSkipAction => ({
    type: actionTypes.KYC_SKIP,
});

export const fetchKycStatus = async (
    dispatch: Dispatch<AppActions>,
    getState: () => AppState,
    isCompletion = false,
): Promise<void> => {
    const { context, kyc } = getState();
    try {
        dispatch(fetchCustomerKycStarted());
        const response: CustomerKycResponse = await get(
            `${actionTypes.RESOURCE_PATH}/kyc`,
            getRequestHeaders(context.config.bankregnr),
        );
        if (isCompletion && response.kycBlocked && !kyc.kycBlockedToggle) {
            dispatch(fetchCustomerKycFailed(customFailed(errorNames.kycBlocked)));
        }
        dispatch(fetchCustomerKycFulfilled(response));
    } catch (error) {
        dispatch(fetchCustomerKycFailed(error));
    }
};
